<template>
  <div class="card shadow">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">
            Instruments
          </h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="items"
      >
        <template v-slot:columns>
          <th>Instrument</th>
          <th>Status</th>
          <th>Message</th>
          <th>Updated</th>
        </template>

        <template v-slot:default="row">
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{ row.item.name }}</span>
              </div>
            </div>
          </th>
          <td class="budget text-center">
            <div class="media align-items-center ml-3">
              <badge class="  badge-dot size mr-4" :type="row.item.color">
                <i  :class="`bg-${row.item.color}`"></i>
              </badge>
            </div>
          </td>
          <td>
            {{row.item.message}}
          </td>

          <td>
            {{dateFormat(row.item.updatedAt)}}
          </td>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: "devices-table-basic",
  created() {
		this.reloadData();
	},
  data() {
    return {
      items: []
    };
  },
  computed: {
    availableDevice() {
      return this.items.filter(item => item.enabled)
    }
  },
  methods:{
    reloadData() {
      this.$resources.devices
        .list(1, {enabled: true})
        .then(response => (this.items = response.data));   
    },
    itemType(item) { 
      return item.enabled ? 'success' : 'danger';
    } ,
    itemTypeStr(item) {
      return item.enabled ? 'On' : 'Off';
    },
    dateFormat(date) {
      return moment(String(date)).format('L LTS');
    }
  }  
};
</script>
<style>
 </style>
